module.exports = __webpack_public_path__ + "d7723c15f3cba5a2b47824c9d61a9c8d.svg";